export default "__VITE_ASSET__DfYX4CgY__"